import React, { Component } from "react"

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"
import MetaTags from 'react-meta-tags';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"
import classnames from "classnames"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { getOrganization } from "store/group/organisation/actions"



class Organisation extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { onGetOrganization } = this.props
    onGetOrganization()
  }

  render() {

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumb title="" breadcrumbItem="Organisation" />
              <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <CardTitle className="h4">Organisation Information</CardTitle>
                    <p className="card-title-desc"></p>

                    <Form>
                      <Row>
                        <Col sm="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="orgname">Name</Label>
                            <Input
                              id="orgname"
                              name="orgname"
                              type="text"
                              className="form-control"
                              value={this.props.organization.groupName}
                              readOnly
                            />
                          </FormGroup>
                          <FormGroup className="mb-3">
                            <Label htmlFor="orgcode">
                              Code
                            </Label>
                            <Input
                              id="orgcode"
                              name="orgcode"
                              type="text"
                              className="form-control"
                              value={this.props.organization.groupCode}
                              readOnly
                            />
                          </FormGroup>
                          
                        </Col>

                        <Col sm="6">
                          
                          <FormGroup className="mb-3">
                            <Label htmlFor="orgdesc">
                              Description
                            </Label>
                            <textarea
                              className="form-control"
                              id="orgdesc"
                              rows="5"
                              value={this.props.organization.groupDescription} 
                              readOnly
                            />
                          </FormGroup>
                          
                        </Col>
                      </Row>

                    </Form>
                    </CardBody>
                </Card>
                <Card>
                  <CardBody>
                    <CardTitle className="h4">Address</CardTitle>
                    <p className="card-title-desc">
                      
                    </p>

                    <Form>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label htmlFor="D">Address</Label>
                            <Input
                              id="orgdesc"
                              name="address1"
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="city">City</Label>
                            <Input
                              id="city"
                              name="city"
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip">Zipcode</Label>
                            <Input
                              id="zip"
                              name="zip"
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </Col>

                        <Col sm={6}>
                        <div className="mb-3">
                            <Label htmlFor="address2">Address</Label>
                            <Input
                              id="address2"
                              name="address2"
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="state">State</Label>
                            <Input
                              id="state"
                              name="state"
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="country">Country</Label>
                            <Input
                              id="country"
                              name="country"
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </Col>
                      </Row>


                    </Form>
                  </CardBody>
                </Card>
                </Col>
              </Row>
            
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

Organisation.propTypes = {
  organization : PropTypes.object,
  onGetOrganization: PropTypes.func,
}

const mapStateToProps = ({ grp }) => ({
  organization : grp.data,

})

const mapDispatchToProps = dispatch => ({
  onGetOrganization: () => dispatch(getOrganization()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Organisation))


